import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/images/welcome/welcome-splash.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "p-d-flex p-flex-column p-align-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Hooray!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "splash" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "splash",
    alt: "game creative character",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "welcome" }
const _hoisted_6 = {
  key: 0,
  class: "welcome-creator w-75 p-text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "creator", -1)
const _hoisted_8 = {
  key: 1,
  class: "welcome-creator w-75 p-text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "brand", -1)
const _hoisted_10 = { class: "p-d-flex p-justify-between p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.show,
      class: "welcome-modal p-col-12 p-md-6 p-xl-4",
      modal: true,
      style: { width: '60vw' },
      dismissableMask: true,
      closable: true,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:show', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-link p-ml-6",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false)))
          }),
          _createVNode(_component_Button, {
            label: "Get Started",
            class: "p-button-text p-button-danger gi-button p-text-uppercase p-mr-6",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:show', false)))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, "Welcome, " + _toDisplayString(_ctx.user.name) + "!", 1)
          ]),
          (_ctx.user.isCreator())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Welcome, "),
                _hoisted_7,
                _createTextVNode(" to G.io! Thank you for signing up. The video tutorial will guide you through the platform. Sit tight and Game on! ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isBrandOwner())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(" Welcome, "),
                _hoisted_9,
                _createTextVNode(" to G.io! Thank you for signing up. The video tutorial will guide you through the platform. Sit tight and Game on! ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}